module.exports = __webpack_public_path__ + "img/bg-cerebro.db14018e.png";